import React from 'react';
import { Layout, Typography } from 'antd';

const { Footer } = Layout;
const { Text } = Typography;

const RecordInfo = () => {
  return (
    <Footer style={{ textAlign: 'center', backgroundColor: '#f0f2f5' }}>
      <Text type="secondary">
        © 2025 通往价值投资之路 版权所有
      </Text>
      <br />
      <Text type="secondary">
        备案号：<a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">浙ICP备2022001086号-2</a>
      </Text>
    </Footer>
  );
};

export default RecordInfo;
